export default __webpack_public_path__ + "static/taskdefinition19-acef4430964d45ec212c9ed5edc3258e.png";